module.exports = __webpack_public_path__ + "static/media/congratsBanner@2x.11c4f3f6.png";